import isFileContentValid from './validation/file';
export default function parseFileString(string) {
    let parsed;
    try {
        parsed = JSON.parse(string);
    }
    catch {
        parsed = undefined;
    }
    if (parsed && isFileContentValid(parsed))
        return parsed;
}
